import 'C:\\Projects\\genkei\\zumeco\\static\\folder\\folder.tsx.esbuild-plugin-windicss.css';
import { __ACCOUNTS_URL_BASE__ } from '@@urls';
import { render } from 'preact';
import { memo, useMemo } from 'preact/compat';
import { noop } from 'ts-essentials';
import type { Doodle } from '../../server/src/models';
import { URL_API_FOLDER_GUEST_LOGOUT } from '../../server/src/urls';
import { COLOR_PANEL_SHADOW } from '../shared/colors';
import '../shared/common.css';
import { Alert } from '../shared/components/Alert';
import { HeaderTop } from '../shared/components/HeaderTop';
import { i18n } from '../shared/i18n';
import { notifyError } from '../shared/notifyError';
import { isAcceptedFile, isIgnorableErrorEvent, supportedDrawingExtensions } from '../shared/utils';
import { ChangeOwnerDialog } from './ChangeOwnerDialog';
import { Collapsible } from './Collapsible';
import { DoodleList } from './DoodleList';
import { FolderHeader } from './FolderHeader';
import { FolderList } from './FolderList';
import { PdfDownloadStatusPanel } from './PdfDownloadStatusPanel';
import { useCurrentUser } from './data/account';
import { dropFile } from './dropFile';
import './folder.css';
import { init, uploadFiles, useCurrentDoodles, useCurrentDoodlesQuery, useCurrentFolder } from './folderState';
['/', '/folders', '/doodles', '/doodles/'].includes(location.pathname) && history.replaceState(0, '', '/folders/');
addEventListener('error', error => {
  if (!isIgnorableErrorEvent(error)) {
    console.error(error);
    notifyError();
  }
});
addEventListener('unhandledrejection', () => notifyError());
dropFile(document.body, files => {
  const accept = supportedDrawingExtensions.split(',');
  const unacceptedFiles = [...files].filter(file => !isAcceptedFile(file, accept));
  if (unacceptedFiles.length !== 0) {
    return alert(`${i18n.unsupportedInputFileType}\n${unacceptedFiles.map(file => file.name).join('\n')}`);
  }
  void uploadFiles(files);
});
const DoodlesPane = memo(() => {
  const query = useCurrentDoodlesQuery();
  const currentUser = useCurrentUser();
  const currentDoodles = useCurrentDoodles();
  const currentFolder = useCurrentFolder();
  if (!currentUser) {
    return null;
  }
  const doodleList = (doodles: readonly Doodle[]) => <DoodleList currentUser={currentUser} doodles={doodles} tenantSharing={!!currentFolder?.tenantSharing} showsFolderName={query.kind === 'search'} />;
  return <section class="relative flex-auto flex flex-col">
      <FolderHeader />
      <div class="overflow-auto flex-auto p-4 xl:p-6" style={`box-shadow: 0 0 2px ${COLOR_PANEL_SHADOW}`}>
        {currentDoodles.message && <Alert className="!mt-0" message={i18n.searchResult.hitsTooMany} />}
        {currentDoodles.grouped ? <div class="-ml-3">
            {Object.entries(currentDoodles.groupedDoodles).map(([name, doodles]) => <Collapsible key={name}>
                <h4>{name}</h4>
                <div class="pl-8 pt-2 pb-4">{doodleList(doodles)}</div>
              </Collapsible>)}
          </div> : doodleList(currentDoodles.doodles)}
      </div>
    </section>;
});
const App = () => {
  const currentUser = useCurrentUser();
  const query = useCurrentDoodlesQuery();
  const folderId = query.kind === 'folder' ? query.folderId : undefined;
  const userMenuItems = useMemo(() => currentUser?.guest && folderId ? [{
    label: i18n.logout,
    onClick: async () => {
      topbar.show();
      await Promise.all([fetch(`${__ACCOUNTS_URL_BASE__}/api/logout`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include'
      }).catch(noop), fetch(URL_API_FOLDER_GUEST_LOGOUT(folderId), {
        method: 'POST'
      })]);
      location.href = __ACCOUNTS_URL_BASE__;
    }
  }] : undefined, [currentUser?.guest, folderId]);
  return <>
      <HeaderTop currentUser={currentUser} userMenuItems={userMenuItems} />
      <main class="flex flex-auto overflow-hidden">
        {currentUser && !currentUser.guest && <FolderList />}
        <DoodlesPane />
        <ChangeOwnerDialog />
      </main>
      <PdfDownloadStatusPanel />
    </>;
};
const rootElement = document.body.insertBefore(document.createElement('div'), document.body.firstElementChild);
rootElement.className = 'flex flex-col h-full';
render(<HeaderTop />, rootElement);
void init(rootElement).then(() => render(<App />, rootElement));